<template>
    <div class="modal-wrapper">
        <div class="modal-content-wrapper">
            <div class="modal-content">
                <div class="title">Дякуємо! <br>Ваш пацієнт {{getPatientName}} розміщений у черзі на консиліум!</div>
                <div class="title-under-text">Ви швидко впорались із завданням та побудували цікавий клінічний випадок! Будь ласка, зачекайте поки колеги зберуть власних пацієнтів, а потім приєднуйтесь до їх обговорення з модератором!</div>
                <div class="actions">
                    <div class="new-patient">
                        <button @click="resetPatient()">Зібрати нового паціента</button>
                    </div>
                    <div class="finish">
                        <button @click="$router.push('/final-screen')">Завершити завдання</button>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    computed : {
        ...mapGetters([
            'getPatientName'
        ])
    },
    methods : {
        ...mapMutations([
            'resetPatient'
        ])
    }
}
</script>

<style lang="scss" scoped>
.webp{
    .modal-wrapper{
        .modal-content-wrapper{
            background: url("../../assets/images/doctor/popup-bg.webp");
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
    }
}

.modal-wrapper{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100vw;
    height: 100vh;

    background-color: rgba(1, 1, 1, 0.7);

    .modal-content-wrapper{
        background: url("../../assets/images/doctor/popup-bg.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% auto;

        max-width: 650px;

        color: #ffffff;
        font-style: normal;
    }

    .modal-content{
        padding: 66px 120px;

        .title{
            font-weight: bold;
            font-size: 24px;
            line-height: 28px;

            padding-bottom: 6px;
        }

        .title-under-text{
            color: #ffffff;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;

            padding: 0 20px;

            padding-bottom: 28px;
        }

        .actions{
            display: flex;
            flex-direction: column;

            button{
                color: #FFFFFF;
                font-size: 14px;
                font-style: normal;
                font-weight: bold;

                background: none;
                outline: none;
                border: none;

                padding: 16px 0;
                width: 15.625vw;
                border-radius: 50px;

                cursor: pointer;
            }

            .new-patient{
                button{
                    margin-bottom: 17px;
                    background: linear-gradient(270.22deg, #F9A900 11.83%, #FF7DA5 139.5%);
                }
            }

            .finish{
                button{
                    background: rgba(139, 126, 107, 0.5);
                    border: 1px solid #FFFFFF;
                }

                button:hover{
                    border-color: #F9A900;
                    color: #F9A900;
                }
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .modal-wrapper{
        .modal-content-wrapper{
            background-size: cover;

            max-width: 70vw;

            color: #ffffff;
            font-style: normal;
        }

        .modal-content{
            padding: 6.250vw 17.458vw;

            .title{
                font-size: 1.823vw;
                line-height: 2.083vw;

                padding-bottom: 0.521vw;
            }

            .title-under-text{
                font-size: 0.938vw;
                line-height: 1.250vw;

                padding: 0 1.563vw;

                padding-bottom: 2.083vw;
            }

            .actions{

                button{
                    font-size: 1.042vw;

                    padding: 1.302vw 0;
                    width: 18.229vw;
                }
            }
        }
    }
}

@media (max-width: 599px){
    .modal-wrapper{
        z-index: 100;
        width: calc(100vw - 5.556vw - 5.556vw);
        height: calc(100% - 6.667vw - 6.667vw);
        padding: 6.667vw 5.556vw;

        .modal-content-wrapper{
            // background: url("../../assets/images/doctor/popup-bg.png");
            background-size: auto 110%;            

            max-width: auto;
            height: 100%;
            padding: 7.778vw 5.556vw 10vw;
            
            border: 1.24337px solid #FFFFFF;
            box-sizing: border-box;
            border-radius: 10px;
        }

        .modal-content{
            padding: 0;

            text-align: left;

            .title{
                font-size: 6.667vw;
                line-height: 8.333vw;

                padding-bottom: 3.333vw;
            }

            .title-under-text{
                color: #ffffff;
                font-size: 5vw;
                line-height: 6.667vw;

                padding: 0;
                padding-right: 3vw;
                padding-bottom: 8.889vw;
            }

            .actions{
                button{
                    font-size: 3.889vw;

                    padding: 4.722vw 0;
                    width: 100%;
                }

                .go-to-promo{
                    button{
                        margin-bottom: 3.333vw;
                    }
                }
            }
        }
    }
}
</style>